import { IconmoonFont } from 'vibo-ui/Icon';
import {
  SectionVisibilityOption,
  SectionVisibilityTypes,
} from 'components/dropdowns/VisibilityDropdown/interfaces';
import { SectionVisibilityRoles } from 'types/enums';

export const sectionVisibilityTypes: SectionVisibilityTypes = {
  dj: SectionVisibilityRoles.dj,
  host: SectionVisibilityRoles.host,
  public: SectionVisibilityRoles.public,
};

export const sectionVisibility: SectionVisibilityOption[] = [
  {
    id: sectionVisibilityTypes.dj,
    name: 'DJ only',
    icon: IconmoonFont['dj-16'],
    roles: [sectionVisibilityTypes.dj],
  },
  {
    id: sectionVisibilityTypes.host,
    name: 'DJ & Host',
    shortName: 'Host',
    icon: IconmoonFont['host-16'],
    roles: [sectionVisibilityTypes.dj, sectionVisibilityTypes.host],
  },
  {
    id: sectionVisibilityTypes.public,
    name: 'Guests',
    icon: IconmoonFont['public-16'],
    roles: [sectionVisibilityTypes.dj, sectionVisibilityTypes.host, sectionVisibilityTypes.public],
  },
];

export const DefaultSongsSort = {
  field: 'createdAt',
  direction: 'desc',
};
